module.exports = __webpack_public_path__ + "/images/cover-cta-libro-lucia.89d5b96.jpg";